howspace.components.progress = (() => {
    'use strict';

    const LABEL_OUTSIDE_THRESHOLD = 20;

    const updateLabelPosition = (progress, percentage) => {
        const label = progress.find('.howspace-progress-label');
        if (label.length === 0) {
            return;
        }

        const isOutside = percentage < LABEL_OUTSIDE_THRESHOLD;
        label.toggleClass('howspace-progress-label-outside', isOutside);
        label.toggleClass('howspace-progress-label-inside', !isOutside);
        label.css('left', (isOutside ? percentage : percentage / 2) + '%');
    };

    const update = (progress, percentage, callback) => {
        if (progress.length === 0 || !progress.hasClass('howspace-progress-initialized')) {
            return;
        }

        if (progress.is('.howspace-progress')) {
            const progressBar = progress.find('.howspace-progress-bar');
            progressBar.attr('aria-valuenow', percentage);
            progressBar.width(percentage + '%');

            const label = progress.find('.howspace-progress-label');
            label.removeClass('d-none');
            label.find('.howspace-progress-percentage').html(percentage + '%');
            updateLabelPosition(progress, percentage);
        } else if (progress.is('.howspace-progress-circle')) {
            const progressCircle = progress.find('.progress');
            const strokeDashArray = parseInt(progressCircle.attr('stroke-dasharray').replace('px', ''));
            const strokeDashOffset = strokeDashArray * ((100 - percentage) / 100);

            progressCircle.css('stroke-dashoffset', strokeDashOffset);
        }

        howspace.dispatchEvent(progress, howspace.components.progress.PROGRESS_UPDATE, {
            percentage: percentage
        });

        if (typeof callback === 'function') {
            callback();
        }
    }

    const reset = (progress, callback) => {
        if (progress.length === 0 || !progress.hasClass('howspace-progress-initialized')) {
            return;
        }

        const progressBar = progress.find('.howspace-progress-bar');
        progressBar.attr('aria-valuenow', 0);
        progressBar.width(0);

        const label = progress.find('.howspace-progress-label');
        label.addClass('d-none');
        label.find('.howspace-progress-percentage').html('');
        updateLabelPosition(progress, 0);

        howspace.dispatchEvent(progress, howspace.components.progress.PROGRESS_UPDATE, {
            percentage: 0
        });

        if (typeof callback === 'function') {
            callback();
        }
    }

    return {
        PROGRESS_UPDATE: 'howspace-progress-update',
        init: (elem) => {
            elem.findIncludingSelf('.howspace-progress:not(.howspace-progress-initialized)').each(function () {
                const progress = $(this);
                progress.addClass('howspace-progress-initialized');
            });
        },
        destroy: (elem) => {
            elem.findIncludingSelf('.howspace-progress.howspace-progress-initialized').each(function () {
                const progress = $(this);
                progress.removeClass('howspace-progress-initialized');
                reset(progress);
            });
        },
        update: update,
        reset: reset
    };

})();
